<template>
  <div class="top">
    <div class="largeAppLinks">
      <h1>Everyone deserves authentic friendships.</h1>
      <h2>Our responsive web-based application helps individuals with special needs (age 13+) find friends at home or on the go, based off their geolocation, diagnosis, age and interests.</h2>
      <h2>New! <a href="https://apps.apple.com/us/app/making-authentic-friendships/id1538026980" target="_blank">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.maf.makingauthenticfriendships" target="_blank">Android</a> apps.</h2>
      <button v-scroll-to="'#AboutUs'" class="learnMore"><img src="../assets/btn_learnmore.png"></button>
      <!-- <div class="linkSet">
        <img class="links" src="../assets/btn_android.png"/>
        <img class="links" src="../assets/btn_ios.png"/>
      </div>
      <p>Coming soon to the App store!</p> -->
    </div>
    <div class="phoneMain">
      <img id="phoneImage" alt="Phone_Main" src="../assets/phone_main.png"/> 
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  components: {
  }
}
</script>

<style scoped>
.top {
  display: flex;
  /* flex-flow: row wrap; */
  justify-content: space-between;
  flex-grow: 100%;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/bg_feature.jpg");
  height: 60vmax;
  width: 100%;
}
h2 a {
  color: white !important;
}
.largeAppLinks {
  text-align: left;
  float: left;
  width: 45%;
  margin: auto;
  font-family: 'chunk';
}
.largeAppLinks h1 {
  color:white;
  font-size: 65px;
  font-family: 'chunk';
  font-weight: inherit;
  padding-left: 20px;
  margin-bottom: 0 !important;
}
.largeAppLinks h2 {
  color:white;
  font-size: 30px;
  font-family: 'futura';
  padding-left: 20px;
  margin-top: .4em !important;
  margin-bottom: 2em !important;
}
.largeAppLinks p {
  color:white;
  font-size: 23px;
  text-transform: uppercase;
  font-family: 'futura';
  font-weight: bold;
  letter-spacing: 2px;
  padding-left: 20px;
}
.learnMore {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  margin-bottom: 1vw;
  align-items: center;
  padding-left: 15px;
}
.linkSet {
  width:100%;
  align-items: center;
  padding-left:20px;
}
.links {
  padding-right:1vw;
  margin-bottom: 0;
}
.phoneMain {
  width:49%;
  margin-bottom:0;
  display: flex;
  justify-content: flex-end;
}
#phoneImage {
  /* width:100%; */
  height:100%;
}

@media screen and (max-width: 330px) {
  .top {
    block-size: 29vmax;
    height: 35vmax !important;
    padding: 2vw 0 0;
  }
  .largeAppLinks h1 {
    font-size: 15px !important;
    margin-left:2vmax;
    margin-right:0;
  }
  .largeAppLinks h2 {
    font-size: 9px !important;
    margin-left:2vmax;
    margin-right:0;
  }
  .largeAppLinks p {
    font-size:1.7vmax;
    margin-top:0;
    letter-spacing: 0px;
  }
  .linkSet {
    margin-left:2vmax;
    margin-right:0;
  }
  .links {
    padding-right:1vmax;
    width:40%;
  }
  .phoneMain {
    width:49% !important;
    margin-bottom:0;
  }
}

@media screen and (min-width: 330px) and (max-width:670px){
  .top {
    block-size: 29vmax;
    height:30vmax !important;
    padding:2vw 0 0 0;
  }
  .largeAppLinks h1 {
    font-size: 15px !important;
    margin-left:2vmax;
    margin-right:0;
  }
  .largeAppLinks h2 {
    font-size: 10px !important;
    margin-left:2vmax;
    margin-right:0;
  }
  .largeAppLinks p {
    font-size:1.7vmax;
    margin-top:0;
    letter-spacing: 0px;
  }
  .linkSet {
    margin-left:2vmax;
    margin-right:0;
  }
  .links {
    padding-right:1vmax;
    width:40%;
  }
  .phoneMain {
    width:49% !important;
    margin-bottom:0;
  }
}

@media screen and (min-width: 670px) and (max-width: 1030px) {
  .top {
    block-size: 29vmax;
    height: 35vmax !important;
    padding: 2vw 0 0 0;
  }
  .largeAppLinks h1 {
    font-size: 28px !important;
    /* margin-left:2vmax; */
    margin-right:0;
  }
  .largeAppLinks h2 {
    font-size: 15px !important;
    /* margin-left:2vmax; */
    margin-right:0;
  }
  .largeAppLinks p {
    font-size:1.7vmax;
    margin-top:0;
    letter-spacing: 0px;
  }
  .linkSet {
    margin-left:2vmax;
    margin-right:0;
  }
  .links {
    padding-right:1vmax;
    width:40%;
  }
  .phoneMain {
    width:49% !important;
    margin-bottom:0;
  }
}
@media screen and (max-width:1365px) {
  .top {
    height: 60vmax;
  }
  .learnMore img{
    width:50%;
    float: left;
  }
  .links{
    width:40%;
  }
  .largeAppLinks h1 {
    font-size: 35px;
  }
  .largeAppLinks h2 {
    font-size: 20px;
    letter-spacing:0px;
  }
  .largeAppLinks p {
    font-size:1vmax;
    letter-spacing:0px;
  }
}
@media screen and (max-width:767px) and (orientation:portrait){

  .largeAppLinks h1 {
    padding-left:0px;
  }
  .largeAppLinks h2 {
    padding-left:0px;
  }
  .largeAppLinks p {
    padding-left:0px;
  }
}

</style>